/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ToolsInputs */

const en_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const ar_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#أدوات`)
};

const bn_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const de_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const es_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const fr_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const pt_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const zh_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const tr_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const ru_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

const pl_svtag_tools = /** @type {(inputs: Svtag_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#TOOLS`)
};

/**
* | output |
* | --- |
* | "#TOOLS" |
*
* @param {Svtag_ToolsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_tools = /** @type {((inputs?: Svtag_ToolsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ToolsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_tools(inputs)
	if (locale === "bn") return bn_svtag_tools(inputs)
	if (locale === "de") return de_svtag_tools(inputs)
	if (locale === "es") return es_svtag_tools(inputs)
	if (locale === "fr") return fr_svtag_tools(inputs)
	if (locale === "pt") return pt_svtag_tools(inputs)
	if (locale === "zh") return zh_svtag_tools(inputs)
	if (locale === "tr") return tr_svtag_tools(inputs)
	if (locale === "ru") return ru_svtag_tools(inputs)
	if (locale === "pl") return pl_svtag_tools(inputs)
	return en_svtag_tools(inputs)
});